import { useState, useEffect } from 'react'
import {
  useCartFormData,
  getItems,
  removeItem,
  emptyCart,
} from 'lib/services/cart'
import { offerRequestSubmittedEvent } from 'lib/services/gtm'
import useEventListener from '@use-it/event-listener'
import CartHeader from 'components/Cart/CartHeader'
import CartItems from 'components/Cart/CartItems'
import SendRequests from 'components/Cart/SendRequests'
import ThankYou from 'components/Cart/ThankYou'
import LoadingSpinner from 'components/LoadingSpinner'
import styles from './Cart.module.scss'

export default function Cart() {
  const formData = useCartFormData()
  const [isReady, setIsReady] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [items, setItems] = useState([])

  /**
   * Fetch cart items from service.
   */
  const getCartItems = async () => {
    const cartItems = await getItems()
    setItems(cartItems)
    setIsLoading(false)
  }

  /**
   * Remove item from cart.
   */
  const removeItemFromCart = (remove) => {
    // Persist change to store.
    removeItem(remove.id)

    // Filter deleted from state.
    const newItems = items.filter((item) => item.id !== remove.id)
    setItems(newItems)
  }

  /**
   * Triggers cleanup on successful order send.
   * Empties cart & shows thankyou.
   */
  const triggerSuccess = () => {
    offerRequestSubmittedEvent(items)
    setIsReady(true)
    setItems([])
    emptyCart()
  }

  /**
   * Trigger item fetch on load.
   *
   * Also update when saved.
   */
  useEffect(() => {
    getCartItems()
  }, [])

  /**
   * Listen for store changes.
   * Update number of offers when they're modified.
   */
  useEventListener('storeChanged', getCartItems)

  return (
    <>
      {!isReady && (
        <>
          <CartHeader formData={formData}>
            <header className={styles.header}>
              <h1 className={`h2 gradient-text ${styles.title}`}>
                Minun tarjouspyyntöni
              </h1>

              <img className={styles.decoration} src="/img/happens.svg" />
            </header>

            <p className={styles.formTitle}>Käyttäjätiedot</p>
          </CartHeader>
          {isLoading && <LoadingSpinner />}
          {!isLoading && (
            <CartItems items={items} removeItem={removeItemFromCart} />
          )}
          {!isLoading && items.length > 0 && (
            <SendRequests
              formData={formData}
              items={items}
              triggerSuccess={triggerSuccess}
            />
          )}

          {!isLoading && items.length === 0 && (
            <div className="container">
              <p>Ei tarjouspyyntöjä korissa</p>
            </div>
          )}
        </>
      )}
      {isReady && (
        <ThankYou
          isLoggedIn={formData.login_email.value !== 'vieras@happens.fi'}
        />
      )}
    </>
  )
}
